/* It's a modal that allows the user to select a group and a point to distribute a form to */
import React, { Component } from "react"
import axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"
import { Button, FormControl, Modal, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap"
import EmployeeDataTypes from "src/pages/hr/Types/EmployeeTypes"
import stateMutator from "../Utils/StateMutator"
import DynamicFormTypes from "../Types/DynamicFormsTypes"
import DynamicFormReferenceTypes from "../Types/DynamicFormReferenceTypes"
import ReleaseDynamicFormBoiler from "../Utils/ReleaseDynamicFormBoiler"
import Select from "react-select"
import normalizeReferenceData from "../Utils/NormalizeReferenceData"
import formReggie from "../Utils/FormReggie"
import ReleaseDynamicFormTypes from "../Types/ReleaseDynamicFormTypesTypes"
import "./ReleaseDynamicForm.css"

interface Props {
    form: DynamicFormTypes
    manageParentState: Function
    employees: Array<EmployeeDataTypes> | []
    formReference: DynamicFormReferenceTypes | any
    userId: string | number
}

interface State {
    input: string
    eventType: string
    busy: boolean
    distribution: ReleaseDynamicFormTypes
}

class ReleaseDynamicForm extends Component<Props, State> {

    DistributionGroupSelectRef: any = null;

    distributionGroups = [
        { PortalDynamicFormDistributionGroupId: 1, Name: "ProfitCenter", data: normalizeReferenceData.normalize(this.props.formReference.ProfitCenters, ["profitCenterId", "profitCenterName"]) },
        { PortalDynamicFormDistributionGroupId: 2, Name: "Company", data: { normalized: [] } },
        { PortalDynamicFormDistributionGroupId: 3, Name: "Employee", data: normalizeReferenceData.normalize(this.props.employees, ["UserId", "DisplayName"]) },
        { PortalDynamicFormDistributionGroupId: 4, Name: "State", data: normalizeReferenceData.normalize(this.props.formReference.States, ["StateId", "StateName"]) },
    ]

    state = {
        input: "",
        eventType: "",
        busy: false,
        distribution: ReleaseDynamicFormBoiler
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    /* Filtering the array of objects `distributionGroups` and returning the first object that matches the
    `Name` property. */
    getDistributions = (text: string) => {
        return this.distributionGroups.filter(obj => {
            return obj.Name === text
        })[0]
    }

    handleChange = (event: { target: { value: any } }) => {
        const input = event.target.value
        let temp = this.state.distribution
        //@ts-ignore
        temp[this.state.eventType] = input
        this.manageState([{ key: "distribution", value: temp }])
    }

    /* A function that is used to clear the value of the `Select` component. */
    clearDropdown = (ref: any) => {
        ref.select.clearValue()
    }

    /* Sending the form to the server. */
    sendForm = () => {
        let rb = this.state.distribution
        rb.CustomFormId = this.props.form.CustomFormId
        rb.PortalDynamicFormDistributionId = -1
        axios.post(`${process.env.REACT_APP_API_URL}/api/company/AddEditDynamicFormDistribution`, { Distributions: [rb] }, AxiosConfig.configValue("min"))
            .then((res: any) => {
                this.manageState([{ key: "busy", value: false }])
                this.props.manageParentState([{ key: "formToRelease", value: null }])
            }).catch((err: any) => {
                this.manageState([{ key: "busy", value: false }])
                this.props.manageParentState([{ key: "formToRelease", value: null }])
            })
    }

    render() {

        const props = this.props
        const state = this.state
        const distribution = state.distribution
        const maxTitleLength = 30
        const distributionGroup = this.getDistributions(distribution.FormDistributeTo)
        const headerText = props.form.Name.length > maxTitleLength ? `${props.form.Name.substring(0, maxTitleLength)}...` : props.form.Name

        const ReleaseDynamicFormToolTip = (text: string) => (
            <Tooltip id="release-dynamic-form-tooltip">
                {text}
            </Tooltip>
        )

        // console.log("df_form ReleaseDynamicForm distributionGroups", distributionGroups)
        // console.log("df_form ReleaseDynamicForm distributionGroup", distributionGroup)
        // console.log("df_form ReleaseDynamicForm props", props)
        // console.log("df_form ReleaseDynamicForm state", state)

        return (
            <div className="ReleaseDynamicForm" >
                <Modal
                    id="distribute-dynamic-form-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="ReleaseDynamicFormModalHeader">
                            <OverlayTrigger placement="top" overlay={ReleaseDynamicFormToolTip(props.form.Name)}>
                                <p>Release:<span>{headerText}</span></p>
                            </OverlayTrigger>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="ReleaseDynamicFormModalBody">
                            <div className="ReleaseDynamicFormModalBodyUpper">
                                <div className="ReleaseDynamicFormModalBodyCheckboxItems ReleaseDynamicFormModalBodyCheckboxItemsLeft">
                                    <div className="ReleaseDynamicFormModalBodyCheckboxItemsHeader">
                                        <p>Group</p>
                                    </div>
                                    {props.formReference.DistributionGroups.map((group: any, i: number) =>
                                        <div className="ReleaseDynamicFormModalBodyCheckboxItem" key={`release-dynamic-form-modal-body-checkbox-group-item-${i}`}>
                                            <FormControl
                                                checked={distribution.FormDistributeTo === group.Name}
                                                onChange={() => {
                                                    let temp = distribution
                                                    temp.FormDistributeTo = group.Name
                                                    this.manageState([{ key: "distribution", value: temp }])
                                                }}
                                                type="checkbox"
                                            />
                                            <p>{group.Name}</p>
                                        </div>)}
                                </div>
                                <div className="ReleaseDynamicFormModalBodyCheckboxItems ReleaseDynamicFormModalBodyCheckboxItemsRight">
                                    <div className="ReleaseDynamicFormModalBodyCheckboxItemsHeader">
                                        <p>Point</p>
                                    </div>
                                    {props.formReference.DistributionPoints.map((point: any, i: number) =>
                                        <div className="ReleaseDynamicFormModalBodyCheckboxItem" key={`release-dynamic-form-modal-body-checkbox-point-item-${i}`}>
                                            <FormControl
                                                checked={distribution.DistributionPoint === point.Name}
                                                onChange={() => {
                                                    let temp = distribution
                                                    temp.DistributionPoint = point.Name
                                                    this.manageState([{ key: "task", value: temp }])
                                                }}
                                                type="checkbox"
                                            />
                                            <p>{point.Name}</p>
                                        </div>)}
                                </div>
                            </div>
                            <div className="ReleaseDynamicFormModalBodyLower">
                                <Select
                                    ref={(ref: any) => { this.DistributionGroupSelectRef = ref }}
                                    placeholder={formReggie.deCamel(distributionGroup.Name)}
                                    // isMulti={true}
                                    //@ts-ignore
                                    options={distributionGroup.data.normalized.map((item: { id: number, text: string }) => ({ value: item.id, label: item.text }))}
                                    onChange={(item: any) => {
                                        let temp = distribution
                                        temp.Value = `${item.value}`
                                        this.manageState([{ key: "distribution", value: temp }])
                                    }}
                                    menuPlacement="bottom"
                                    maxMenuHeight={300}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="ReleaseDynamicFormModalFooter">
                            {!state.busy && <div className="ReleaseDynamicFormModalFooterNotBusy">
                                <Button variant="secondary" onClick={() => props.manageParentState([{ key: "formToRelease", value: null }])}>Cancel</Button>
                                <Button onClick={() => this.sendForm()}>Release</Button>
                            </div>}
                            {state.busy && <div className="ReleaseDynamicFormModalFooterBusy">
                                <Spinner animation="border" />
                            </div>}
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}

export default ReleaseDynamicForm